export default "__VITE_ASSET__D2URl6Zp__"